/**
 * Whether a crumb should render as the current page.
 *
 * Context: a trail usually ends at the page you are on, so the last crumb is current by default.
 * But a trail can end at a *parent* — the BOQ and account-details trails both end at a record
 * whose tabs are child routes, so their final crumb stays a link that returns you to the tab you
 * started on. Those callers set `isCurrent: false` and this honours it.
 *
 * It lives here rather than in either renderer because **both** the app's `Breadcrumb` wrapper and
 * `BaseLayout` map the same store items, and a rule only one of them applied would be silently
 * ignored on whichever path the caller did not have in mind.
 */
export const isCurrentCrumb = (
  item: { isCurrent?: boolean },
  index: number,
  total: number,
): boolean => item.isCurrent ?? index === total - 1;
